import * as colors from '../../utils/colors';
import { TagLabel } from '../../wave/types/tag.type';
import { Wave } from '../../wave/types/wave.type';
import { isWaveOfType } from '../../wave/utils/wave.util';
import { LaddergramItemConfig } from '../types/laddergram.type';
import { squareToPixel } from './graph.utils';

export const isType = (waveTags: TagLabel[], ...tags: TagLabel[]) => {
  const tagSet = new Set(waveTags);
  return tags.some((tag) => tagSet.has(tag));
};

export const isLinkable = (wave: Wave): boolean => {
  if (isWaveOfType(wave, 'P')) {
    return !isType(wave.tags, 'non-conducted');
  }
  if (isWaveOfType(wave, 'QRS')) {
    return !isType(wave.tags, 'ectopic', 'junctional', 'paced');
  }
  return false;
};

export const getConfigForWave = (wave: Wave): LaddergramItemConfig => {
  const bordered = isType(wave.tags, 'premature');
  switch (wave.type) {
    case 'P':
      return { color: colors.PWaveBlue, yOffset: 0, bordered };
    case 'QRS':
      return {
        color: colors.QRSWaveRed,
        yOffset: squareToPixel(1 / 2),
        bordered,
      };
    default:
      return { yOffset: 0, bordered };
  }
};
